import * as React from 'react';
import { SVGProps } from 'react';

const HelpChatIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox='0 0 43 40' xmlns="http://www.w3.org/2000/svg" {...props}>
    <g fill="none" fillRule="evenodd">
      <path
        d="M26.73 2.665C12.77 3.685 6.385 20.158 15.444 30.216c-3.119-.583-5.94-2.04-8.02-4.227L0 29.05l3.415-9.913C-.297 5.58 15.147-5.207 26.73 2.665Z"
        fill="#000"
        fillRule="nonzero"
      />
      <path
        d="M27.818 4.649C36.22 4.649 43 11.476 43 19.757c0 4.503-1.916 8.57-5.159 11.33l1.916 8.427-8.99-4.94c-9.434 1.889-17.983-5.375-17.983-14.817 0-8.28 6.78-15.108 15.034-15.108Z"
        fill="#000"
        fillRule="nonzero"
      />
      <circle fill="#FFF" cx={22.662} cy={19.176} r={1.743} />
      <circle fill="#FFF" cx={28.473} cy={19.176} r={1.743} />
      <circle fill="#FFF" cx={35.446} cy={19.176} r={1.743} />
    </g>
  </svg>
);

export default HelpChatIcon;